import { render, staticRenderFns } from "./FeeStandard.vue?vue&type=template&id=004feac2&scoped=true&"
import script from "./FeeStandard.vue?vue&type=script&lang=js&"
export * from "./FeeStandard.vue?vue&type=script&lang=js&"
import style0 from "./FeeStandard.vue?vue&type=style&index=0&id=004feac2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004feac2",
  null
  
)

export default component.exports